/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type FundFamilyEventSubTypeEnum = typeof FundFamilyEventSubTypeEnum[keyof typeof FundFamilyEventSubTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FundFamilyEventSubTypeEnum = {
  fund_family_config: 'fund_family_config',
  fund_family_dates: 'fund_family_dates',
  fund_family_entity: 'fund_family_entity',
  fund_family_entity_with_allocation_setup: 'fund_family_entity_with_allocation_setup',
  fund_family_investment: 'fund_family_investment',
  credit_facility_version: 'credit_facility_version',
  credit_facility_loan_version: 'credit_facility_loan_version',
  borrowing_base_group_version: 'borrowing_base_group_version',
  security_ownership_version: 'security_ownership_version',
  allocation_rule: 'allocation_rule',
  allocation_rule_lookup: 'allocation_rule_lookup',
  allocation_rule_graph_version: 'allocation_rule_graph_version',
  allocation_rule_graph_use_version: 'allocation_rule_graph_use_version',
  fee: 'fee',
  fee_basis: 'fee_basis',
  fee_basis_category: 'fee_basis_category',
  fee_calculations: 'fee_calculations',
  investor_class: 'investor_class',
  notice: 'notice',
  notice_document_template: 'notice_document_template',
  security_ownership: 'security_ownership',
  transaction_calculation: 'transaction_calculation',
  transaction_code_config: 'transaction_code_config',
  waterfall: 'waterfall',
  waterfall_config: 'waterfall_config',
  waterfall_tier_mapping: 'waterfall_tier_mapping',
  fund_family_event_event_adjustment: 'fund_family_event_event_adjustment',
  commitment_adjustment: 'commitment_adjustment',
  late_apply_fee_offset_adjustment: 'late_apply_fee_offset_adjustment',
  adjustment_event: 'adjustment_event',
  drawdown: 'drawdown',
  paydown: 'paydown',
  reallocation: 'reallocation',
  post_interest: 'post_interest',
  merge_tranches: 'merge_tranches',
} as const;
